import {FILTER_ALL, FILTER_CUSTOM, FILTER_NONE} from './filters';

export default [
  {key: FILTER_ALL, label: 'Alle Prod.'},
  {key: FILTER_CUSTOM, label: 'gefiltert (Prod.)'},
  {key: FILTER_NONE, label: 'Keine Prod.'},
];
